import { api } from "@/lib/api";

export interface PublicTicketBody {
  name: string;
  email: string;
  phone?: string | null;
  subject: string;
  description: string;
  company?: string | null;
  website?: string; // honeypot — leave empty
  screenshot?: File | null;
}

export interface PublicTicketResult {
  reference: string;
  message: string;
}

export function submitPublicTicket(body: PublicTicketBody): Promise<PublicTicketResult> {
  // Multipart so an optional screenshot can ride along with the fields.
  const form = new FormData();
  form.set("name", body.name);
  form.set("email", body.email);
  form.set("subject", body.subject);
  form.set("description", body.description);
  if (body.phone) form.set("phone", body.phone);
  if (body.company) form.set("company", body.company);
  form.set("website", body.website ?? "");
  if (body.screenshot) form.set("screenshot", body.screenshot);
  return api.upload<PublicTicketResult>("/public/tickets", form);
}

export interface PublicStatusEvent {
  status: string;
  label: string;
  at: string;
}

export interface PublicStatus {
  ticket_number: string;
  subject: string;
  status: string;
  status_label: string;
  created_at: string;
  updated_at: string;
  engineer_name: string | null;
  resolution: string | null;
  can_confirm: boolean;
  timeline: PublicStatusEvent[];
}

export function checkTicketStatus(ticket_number: string, email: string): Promise<PublicStatus> {
  return api.post<PublicStatus>("/public/tickets/status", { ticket_number, email });
}

export function confirmTicketResolved(
  ticket_number: string,
  email: string,
): Promise<{ message: string }> {
  return api.post<{ message: string }>("/public/tickets/confirm", { ticket_number, email });
}
